import React from 'react';

import { KolLink } from '@public-ui/react-v19';

import type { FC } from 'react';
import { SampleBlock } from '../SampleBlock';
import { SampleDescription } from '../SampleDescription';

export const LinkTarget: FC = () => (
	<>
		<SampleDescription>
			<p>
				This sample shows KolLink with different <code>_target</code>-properties.
			</p>
		</SampleDescription>

		<SampleBlock id="target" className="text-base d-flex gap-4">
			<ul>
				<li>
					<KolLink _href="#/back-page" _label="Link without target" />
				</li>
				<li>
					<KolLink _href="#/back-page" _label="Link with target (_self)" _target="_self" />
				</li>
				<li>
					<KolLink _href="#/back-page" _label="Link with target (_blank)" _target="_blank" />
				</li>
				<li>
					<KolLink _href="#/back-page" _icons="kolicon-house" _hideLabel _label="Link without target" />
				</li>
				<li>
					<KolLink _href="#/back-page" _icons="kolicon-house" _hideLabel _label="Link with target (_self)" _target="_self" />
				</li>
				<li>
					<KolLink _href="#/back-page" _icons="kolicon-house" _hideLabel _label="Link with target (_blank)" _target="_blank" />
				</li>
			</ul>
		</SampleBlock>
	</>
);
